/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';


function values(createHEValue) {
  return (healthEntryCategoryState, languageCode) => {
    healthEntryCategoryState.values = healthEntryCategoryState.values || [];

    return {
      get: () => healthEntryCategoryState.values,
      getById: (id) => {
        const hev = _.find(healthEntryCategoryState.values, { id });
        return createHEValue(hev, languageCode);
      },
      hasValues: () => healthEntryCategoryState.values.length > 0,
      mostRecent: () => {
        const hev = healthEntryCategoryState.values[0] || {};
        return createHEValue(hev, languageCode);
      },
      count: () => healthEntryCategoryState.values.length,
      hasAnyFlagged: () => !!healthEntryCategoryState.values.find(v => v.flagged),
      hasAnyComments: () => !!healthEntryCategoryState.values.find(v => (v.comments.length > 0)),
      hasAnyAttachments: () => !!healthEntryCategoryState.values.find(v => (v.attachment_count.file || v.attachment_count.contact || v.attachment_count.note)),
    };
  };
}

export default values;
